/**
 Class Translate Data Server to React Items Or Reverse

 */

class TranslateApi {

    constructor() {
        console.log("create translate");
    }

    static dateToRHF = (stamp: string) => {
        return stamp && new Date(+stamp);
    }
}

export default TranslateApi;
